define(
    '../core/Storage.js',[
        'config',
        'loader'
    ],
    function(Config, Loader)
    {

        var $ = Loader.$;
        var _ = Loader._;

        var storage = {};

        try {
            localStorage.setItem('storage', 1);
            localStorage.removeItem('storage', 1);
            storage = localStorage;
        } catch(e) {
            storage = new LocalStorageAlternative();
        }

        var _isAvailable = function()
        {
            try {
                return 'localStorage' in window && window['localStorage'] !== null;
            } catch (e) {
                return false;
            }
        };

        var _set = function(key, value)
        {
            if (!_isAvailable()) return;

            if (typeof value == 'object') {
                value = JSON.stringify(value);
            }
            try {
                storage.setItem(key, value);
            } catch (e) {
//                if (e == QUOTA_EXCEEDED_ERR) {
                if (e.name == "QuotaExceededError") {
                    _clear();
                    storage.setItem(key, value);
                }
            }
        };

        var _get = function(key)
        {
            if (!_isAvailable()) return false;

            var value = storage.getItem(key);

            try {
                return JSON.parse(value);
            } catch(e) {
                return value;
            }
        };

        var _remove = function(key)
        {
            if (!_isAvailable()) return;

            storage.removeItem(key);
        };

        var _clear = function()
        {
            if (!_isAvailable()) return;

            storage.clear();
        };

        function LocalStorageAlternative() {

            var structureLocalStorage = {};

            this.setItem = function (key, value) {
                structureLocalStorage[key] = value;
            };

            this.getItem = function (key) {
                return structureLocalStorage[key];
            };

            this.removeItem = function (key) {
                structureLocalStorage[key] = undefined;
            };
        }

        return {
            isAvailable: _isAvailable,
            set: _set,
            get: _get,
            remove: _remove,
            clear: _clear
        };
    }
);

